export default __webpack_public_path__ + "static/lsa-screens-2-863c9dc2614899ead5ff09b10636da3a.jpg";